import React from "react";
import Skeleton from "../../components/Skeleton/Skeleton";

/**
 * Placeholder row for the notifications list (matches .notification-row layout).
 */
function NotificationRowSkeleton() {
    return (
        <div
            className="notification-row"
            style={{ cursor: "default", pointerEvents: "none" }}
            aria-hidden
        >
            <div className="notification-icon">
                <Skeleton width="24px" height="24px" borderRadius="8px" className="m-0 p-0" />
            </div>
            <div className="notification-content">
                <Skeleton width="75%" height="16px" borderRadius="8px" className="m-0 p-0" />
                <Skeleton width="55%" height="14px" borderRadius="7px" className="m-0 p-0" />
            </div>
        </div>
    );
}

export default NotificationRowSkeleton;
